import { gql } from '@apollo/client/core';

export enum CategoryGroupName {
  MODULE = 'Module',
  ROLE_BUNDLE = 'Role Bundle',
}

export interface Role {
  id: string;
  name: string;
  permissions: string[];
  description: string;
}

export interface RoleCategory {
  categoryName: string;
  roles: Role[];
}

export interface RoleSelectionViewModel {
  categoryGroupName: string;
  categories: RoleCategory[];
}

export const GET_ALL_ROLES = gql`
  query getRoles($organisation: String!) {
    allRolesSelectionViewModel(organisation: $organisation) {
      categoryGroupName
      categories {
        categoryName
        roles {
          id
          name
          permissions
          description
        }
      }
    }
  }
`;
